module.exports = __webpack_public_path__ + "images/25bfbdd4ce0e286c15569f069e662927-kitchen-copper.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen-copper.jpg
// module id = ./src/assets/images/content/kitchen-copper.jpg
// module chunks = 0